export const transformLowerCase = (text) => {
    var firstLetter = text.charAt(0);
    var restOfText = text.substring(1).toLowerCase();

    return firstLetter + restOfText;
}
